// @atlas/shared — közös tiszta util-ok és business enum-ok
//
// nem ide tartozik:
//   - API request/response shape  → @atlas/contracts
//   - az adat sémája/típusai       → Odin (resource bus; az Atlasnak nincs DB-je)
//
// ide tartozik:
//   - pénz-aritmetika (fixpontos, ×100-skálázott egész — `invoice.ts`, `decimal.ts`; brand típus nincs)
//   - tiszta util-ok mindkét runtime-on (api + web)
//   - business enum-ok (amikre az app↔frontend contractok hivatkoznak)
/**
 * Ügyfél-státusz (CRM adat-parity): a legacy `active`/`pending`/`inactive` 1:1. Ez a business enum
 * él a contractokban (`@atlas/contracts`) ÉS a frontenden (badge/pill), ezért a közös `@atlas/shared`-ben
 * a forrás-igazsága. Az Odin platform-mag `EntityStatus`-a ettől független (a `clients/client` profil
 * `statusOriginal` mezője hordozza az itt definiált CRM-státuszt).
 */
export const CLIENT_STATUSES = ['active', 'pending', 'inactive'];
// Számla-domén: kanonikus fixpontos összeg-számítás + enum forrás-igazságok (contract + UI + BFF közös).
// A `.js` kiterjesztés KELL: a csomag `type: module`, az ESM buildet az api Node-dal (nem bundlerrel) futtatja,
// és a Node ESM megköveteli az explicit kiterjesztést a relatív importon (különben ERR_MODULE_NOT_FOUND).
export * from './invoice.js';
export * from './finance-permissions.js';
export * from './invoice-dates.js';
// A rich-text (WYSIWYG) HTML KÖZÖS policy-ja — a web és a BFF szanitálói is EBBŐL épülnek (nincs három lista).
export * from './rich-text-policy.js';
// Ékezet-érzéketlen szabad-szöveges illesztés — a web opció-szűrői ÉS a BFF globális keresője közös alapja.
export * from './search-text.js';
// Fiók-domainek: normalizálás + szabad szöveg bontása + az állapot-enum (ETL · BFF · átviteli szkript közös).
export * from './account-domains.js';
// Fixpontos Decimal-string aritmetika (negatív- és vessző-toleráns, nem dobó) — a kiadás-oldal összegzése,
// a NAV-import, a kiadás-űrlap és a pénzügyi egyenleg KÖZÖS rétege. A szigorú, számla-számítási párja az
// `invoice.js` `parseDecimal2`-je.
export * from './decimal.js';
// A fiók külső rendszer-azonosítói (rendszerenként több) — a szerződés, a BFF, a web és az ETL bekötő szkriptje
// közös olvasási szabálya (a régi három mezőből determinisztikus visszaeséssel).
export * from './account-integrations.js';
// Az ISMÉTLŐDŐ MEGBESZÉLÉS szabályának kibontása alkalmakra — a BFF (hiteles kibontás + ütközés) és a web
// (űrlap-előnézet) közös, falióra-helyes (DST) logikája.
export * from './meeting-recurrence.js';
// Eszköz-típusok: a típus-kulcsok + a hardver/szoftver besorolás egy forrása (BFF kategória-szabály + web opciók).
export * from './asset-types.js';
// Megbeszélés-helyszínek: a helyszín-kulcsok egy forrása (szerződés-szűrő + szerkesztő + naptár-szín + levél-címke).
export * from './meeting-locations.js';
// a megszólítás közös szabálya (becenév → keresztnév)
export * from './person-address.js';
// a partner-portál feature-jogai (fiókonként érvényesek — a BFF kapui és a web menü-kapui közös forrása)
export * from './portal-permissions.js';
// A kezdőlap (Áttekintés) csempe-katalógusa + az elrendezés feloldása/validációja — a web és a BFF közös forrása.
export * from './dashboard-tiles.js';
export * from './dashboard-layout.js';
// Magyar névnapok (naptár + szökőév-eltolás + keresztnév-illesztés) — az „Ünnepeltek" csempe forrása.
export * from './name-days/name-days.js';
// A jegy zárt értékkészletei (típus + státusz) — az Odin registry-enum tükre, egy forrásból.
export * from './ticket-enums.js';
//# sourceMappingURL=index.js.map